import { makeStyles } from '@material-ui/styles';
// import tinycolor from 'tinycolor2';
export default makeStyles(theme => ({

    st0: {
        fill: '#FFFFFF',
    },

}));
